<template>
  <div class="card order-info">
    <!-- <div class="info">
      <van-row class="info-line">
        <van-col :span="12">
          <span class="info-title">订单类型：</span>
          <span class="info-value">挂牌</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">订单号：</span>
          <span class="info-value">
            <router-link to="/home" class="order-no">789456123</router-link>
          </span>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">订单生成时间：</span>
        <span class="info-value">2019-07-19 12:00</span>
      </van-row>
    </div>-->
    <div class="info buyer-info van-hairline--top">
      <div class="info-header">
        <img src="@/assets/imgs/buyer.png" />买家信息
      </div>
      <van-row class="info-line">
        <span class="info-title">公司名称：</span>
        <span class="info-value">{{userInfo.companyAuthModel.companyName}}</span>
      </van-row>
      <van-row class="info-line">
        <van-col :span="12">
          <span class="info-title">联 系 人 ：</span>
          <span class="info-value">{{userInfo.realName}}</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">联系电话：</span>
          <span class="info-value">{{userInfo.mobilePhone}}</span>
        </van-col>
      </van-row>
    </div>
    <div class="info seller-info van-hairline--top">
      <div class="info-header">
        <img src="@/assets/imgs/seller.png" />卖家信息
      </div>
      <van-row class="info-line">
        <span class="info-title">公司名称：</span>
        <span class="info-value">{{listingDetail.sellerName}}</span>
      </van-row>
      <van-row class="info-line">
        <van-col :span="12">
          <span class="info-title">联 系 人 ：</span>
          <span class="info-value">{{listingDetail.sellerContactName}}</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">联系电话：</span>
          <span class="info-value">{{listingDetail.sellerContactTel}}</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderInfoCard",
  props: {
    userInfo: Object,
    listingDetail: Object,
  },
  data() {
    return {};
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  margin-buttom: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
    }
  }

  .buyer-info, .seller-info {
    .info-line {
      color: #666666;
    }
  }
}
</style>